import React from 'react';

// Package-specific field configurations
const PACKAGE_CONFIGS = {
  Starter: {
    bookkeeper_frequency_hardcoded: 'Monthly',
    sales_invoices_hardcoded: 'N/A',
    suppliers_invoices_hardcoded: 'Monthly',
    payments_hardcoded: 'N/A',
    payroll_hardcoded: 'N/A',
    num_employees_hardcoded: 'N/A',
    num_banks_hardcoded: '1',
    num_payment_platforms_hardcoded: '1',
    bas_frequency_options: ['Monthly', 'Quarterly', 'Annually'],
    payg_frequency_options: ['Monthly', 'Quarterly'],
    show_superannuation: false,
    reports_type: 'Annual'
  },
  Essential: {
    bookkeeper_frequency_hardcoded: 'Monthly',
    sales_invoices_hardcoded: 'N/A',
    suppliers_invoices_hardcoded: 'Monthly',
    payments_hardcoded: 'N/A',
    payroll_hardcoded: 'Monthly',
    num_employees_hardcoded: '1',
    num_banks_hardcoded: '1',
    num_payment_platforms_hardcoded: '1',
    bas_frequency_hardcoded: 'Quarterly',
    payg_frequency_hardcoded: 'Quarterly',
    superannuation_hardcoded: 'Quarterly',
    show_superannuation: true,
    reports_type: 'Quarterly'
  },
  Growth: {
    bookkeeper_frequency_hardcoded: 'Weekly',
    sales_invoices_hardcoded: 'N/A',
    suppliers_invoices_hardcoded: 'Weekly',
    payments_hardcoded: 'N/A',
    payroll_hardcoded: 'Monthly',
    num_employees_options: ['1', '2', '3'],
    num_banks_options: ['1', '2'],
    num_payment_platforms_options: ['0', '1'],
    bas_frequency_hardcoded: 'Quarterly',
    payg_frequency_hardcoded: 'Quarterly',
    superannuation_hardcoded: 'Quarterly',
    show_superannuation: true,
    reports_type: 'Quarterly'
  },
  'BAS Only': {
    hide_bookkeeper_tasks: true,
    bas_frequency_options: ['Monthly', 'Quarterly'],
    payg_frequency_options: ['Not Applicable', 'Monthly', 'Quarterly'],
    show_superannuation: false,
    reports_hardcoded: 'N/A',
    reports_type: 'N/A'
  },
  Pro: {
    bookkeeper_frequency_hardcoded: 'Daily',
    sales_invoices_hardcoded: 'N/A',
    suppliers_invoices_hardcoded: 'Daily',
    payments_hardcoded: 'N/A',
    payroll_options: ['Fortnightly', 'Monthly'],
    num_employees_options: ['1', '2', '3', '4', '5'],
    num_banks_options: ['1', '2', '3'],
    num_payment_platforms_options: ['0', '1', '2'],
    bas_frequency_options: ['Monthly', 'Quarterly'],
    payg_frequency_options: ['Monthly', 'Quarterly'],
    superannuation_hardcoded: 'Quarterly',
    show_superannuation: true,
    reports_type: 'Monthly'
  },
  'Start-up Pack': {
    is_one_off: true,
    hide_software_section: true,
    hide_bookkeeper_section: true,
    hide_client_requirements: true,
    show_tax_section: true,
    show_superannuation: false,
    bas_frequency_options: ['Not Applicable', 'Monthly', 'Quarterly', 'Annually'],
    payg_frequency_options: ['Not Applicable', 'Monthly', 'Quarterly'],
    reports_type: 'N/A'
  },
  'Clean Slate': {
    is_one_off: true,
    hide_software_section: false,
    hide_bookkeeper_section: true,
    hide_client_requirements: true,
    show_tax_section: true,
    show_superannuation: false,
    bas_frequency_options: ['Not Applicable', 'Monthly', 'Quarterly', 'Annually'],
    payg_frequency_options: ['Not Applicable', 'Monthly', 'Quarterly'],
    reports_type: 'N/A'
  }
};

export function getPackageConfig(packageType) {
  return PACKAGE_CONFIGS[packageType] || PACKAGE_CONFIGS.Starter;
}

export function BookkeeperFrequencyField({ packageType, value, onChange, errors }) {
  const config = getPackageConfig(packageType);
  
  if (config.bookkeeper_frequency_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="bookkeeper_frequency">Frequency</label>
        <input
          type="text"
          id="bookkeeper_frequency"
          value={config.bookkeeper_frequency_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
      </div>
    );
  }
  
  return (
    <div className="form-group">
      <label htmlFor="bookkeeper_frequency">Frequency</label>
      <select
        id="bookkeeper_frequency"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {config.bookkeeper_frequency_options.map(option => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  );
}

export function SalesInvoicesField({ packageType, value, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (config.sales_invoices_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="sales_invoices">Enter Sales Invoices</label>
        <input
          type="text"
          id="sales_invoices"
          value={config.sales_invoices_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
      </div>
    );
  }
  
  return (
    <div className="form-group">
      <label htmlFor="sales_invoices">Enter Sales Invoices</label>
      <select
        id="sales_invoices"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Not Required</option>
        <option value="Weekly">Weekly</option>
        <option value="Monthly">Monthly</option>
      </select>
    </div>
  );
}

export function SuppliersInvoicesField({ packageType, value, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (config.suppliers_invoices_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="suppliers_invoices">Enter Suppliers Invoices</label>
        <input
          type="text"
          id="suppliers_invoices"
          value={config.suppliers_invoices_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
      </div>
    );
  }
  
  return (
    <div className="form-group">
      <label htmlFor="suppliers_invoices">Enter Suppliers Invoices</label>
      <select
        id="suppliers_invoices"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Not Required</option>
        <option value="Weekly">Weekly</option>
        <option value="Monthly">Monthly</option>
      </select>
    </div>
  );
}

export function PaymentsFrequencyField({ packageType, value, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (config.payments_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="payments_frequency">Make Payments</label>
        <input
          type="text"
          id="payments_frequency"
          value={config.payments_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
      </div>
    );
  }
  
  return (
    <div className="form-group">
      <label htmlFor="payments_frequency">Make Payments</label>
      <select
        id="payments_frequency"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Not Required</option>
        <option value="Weekly">Weekly</option>
        <option value="Fortnightly">Fortnightly</option>
      </select>
    </div>
  );
}

export function PayrollField({ packageType, value, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (config.payroll_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="payroll_frequency">Payroll Frequency</label>
        <input
          type="text"
          id="payroll_frequency"
          value={config.payroll_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
      </div>
    );
  }
  
  const config_options = config.payroll_options || ['Monthly'];
  
  return (
    <div className="form-group">
      <label htmlFor="payroll_frequency">Payroll Frequency</label>
      <select
        id="payroll_frequency"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Not Required</option>
        {config_options.map(option => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  );
}

export function EmployeesField({ packageType, value, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (config.num_employees_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="num_employees">Number of Employees</label>
        <input
          type="text"
          id="num_employees"
          value={config.num_employees_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
      </div>
    );
  }
  
  if (config.num_employees_options) {
    return (
      <div className="form-group">
        <label htmlFor="num_employees">Number of Employees</label>
        <select
          id="num_employees"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">Select...</option>
          {config.num_employees_options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    );
  }
  
  return (
    <div className="form-group">
      <label htmlFor="num_employees">Number of Employees</label>
      <input
        type="number"
        id="num_employees"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        min="0"
      />
    </div>
  );
}

export function BanksField({ packageType, value, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (config.num_banks_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="num_banks">No. Banks (inc. credit cards)</label>
        <input
          type="number"
          id="num_banks"
          value={config.num_banks_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
        <p className="help-text" style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
          {packageType} package includes {config.num_banks_hardcoded} bank account(s)
        </p>
      </div>
    );
  }
  
  if (config.num_banks_options) {
    return (
      <div className="form-group">
        <label htmlFor="num_banks">No. Banks (inc. credit cards)</label>
        <select
          id="num_banks"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">Select...</option>
          {config.num_banks_options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    );
  }
  
  return (
    <div className="form-group">
      <label htmlFor="num_banks">No. Banks (inc. credit cards)</label>
      <input
        type="number"
        id="num_banks"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        min="0"
      />
    </div>
  );
}

export function PaymentPlatformsField({ packageType, value, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (config.num_payment_platforms_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="num_payment_platforms">Payment Platforms (Stripe/PayPal etc)</label>
        <input
          type="number"
          id="num_payment_platforms"
          value={config.num_payment_platforms_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
        <p className="help-text" style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
          {packageType} package includes {config.num_payment_platforms_hardcoded} payment platform
        </p>
      </div>
    );
  }
  
  if (config.num_payment_platforms_options) {
    return (
      <div className="form-group">
        <label htmlFor="num_payment_platforms">Payment Platforms (Stripe/PayPal etc)</label>
        <select
          id="num_payment_platforms"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {config.num_payment_platforms_options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    );
  }
  
  return (
    <div className="form-group">
      <label htmlFor="num_payment_platforms">Payment Platforms (Stripe/PayPal etc)</label>
      <input
        type="number"
        id="num_payment_platforms"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        min="0"
      />
    </div>
  );
}

export function BASFrequencyField({ packageType, value, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (config.bas_frequency_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="bas_frequency">BAS Lodgement Frequency</label>
        <input
          type="text"
          id="bas_frequency"
          value={config.bas_frequency_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
      </div>
    );
  }
  
  return (
    <div className="form-group">
      <label htmlFor="bas_frequency">BAS Lodgement Frequency</label>
      <select
        id="bas_frequency"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {config.bas_frequency_options.map(option => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  );
}

export function PAYGFrequencyField({ packageType, value, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (config.payg_frequency_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="payg_frequency">PAYG Withholding Frequency</label>
        <input
          type="text"
          id="payg_frequency"
          value={config.payg_frequency_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
      </div>
    );
  }
  
  return (
    <div className="form-group">
      <label htmlFor="payg_frequency">PAYG Withholding Frequency</label>
      <select
        id="payg_frequency"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Not Applicable</option>
        {config.payg_frequency_options.map(option => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  );
}

export function SuperannuationField({ packageType, value, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (!config.show_superannuation) {
    return null;
  }
  
  if (config.superannuation_hardcoded) {
    return (
      <div className="form-group">
        <label htmlFor="superannuation_submission">Superannuation Submission</label>
        <input
          type="text"
          id="superannuation_submission"
          value={config.superannuation_hardcoded}
          disabled
          style={{ backgroundColor: 'var(--bg-gray-100)', cursor: 'not-allowed' }}
        />
      </div>
    );
  }
  
  return (
    <div className="form-group">
      <label htmlFor="superannuation_submission">Superannuation Submission</label>
      <select
        id="superannuation_submission"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="Quarterly">Quarterly</option>
        <option value="Monthly">Monthly</option>
        <option value="Annually">Annually</option>
        <option value="N/A">N/A</option>
      </select>
    </div>
  );
}

export function ReportsSection({ packageType, monthlyReports, annualReports, onChange }) {
  const config = getPackageConfig(packageType);
  
  if (config.reports_type === 'N/A') {
    return (
      <>
        <h3 style={{ marginTop: '2rem' }}>Client Requirements</h3>
        <hr style={{ margin: '1rem 0', borderTop: '2px solid var(--primary-navy)' }} />
      </>
    );
  }
  
  if (config.reports_type === 'Monthly') {
    return (
      <>
        <h3 style={{ marginTop: '2rem' }}>Client Requirements</h3>
        <hr style={{ margin: '1rem 0', borderTop: '2px solid var(--primary-navy)' }} />
        
        <div className="form-group">
          <label htmlFor="monthly_reports">Monthly Reports</label>
          <textarea
            id="monthly_reports"
            value={monthlyReports}
            onChange={(e) => onChange('monthly_reports', e.target.value)}
            rows="3"
            placeholder="P&L & Balance Sheet reviews, Cash flow forecast management, Maintain asset depreciation schedule"
          />
          <p className="help-text" style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
            Pro package includes monthly reporting services
          </p>
        </div>
      </>
    );
  }
  
  if (config.reports_type === 'Quarterly') {
    return (
      <>
        <h3 style={{ marginTop: '2rem' }}>Client Requirements</h3>
        <hr style={{ margin: '1rem 0', borderTop: '2px solid var(--primary-navy)' }} />
        
        <div className="form-group">
          <label htmlFor="monthly_reports">Quarterly Reports</label>
          <textarea
            id="monthly_reports"
            value={monthlyReports}
            onChange={(e) => onChange('monthly_reports', e.target.value)}
            rows="2"
            placeholder="P&L and Balance sheet review"
          />
        </div>
      </>
    );
  }
  
  return (
    <>
      <h3 style={{ marginTop: '2rem' }}>Client Requirements</h3>
      <hr style={{ margin: '1rem 0', borderTop: '2px solid var(--primary-navy)' }} />
      
      <div className="form-group">
        <label htmlFor="annual_reports">Annual Reports</label>
        <select
          id="annual_reports"
          value={annualReports}
          onChange={(e) => onChange('annual_reports', e.target.value)}
        >
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>
    </>
  );
}
